/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Icon, NumericInput, Popover, PopoverInteractionKind, Position, Size, Tooltip } from "@blueprintjs/core"
import { MouseEvent, useEffect, useRef } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import useClickOutside from "src/modules/pe-fest-module/widgets/hooks/useClickOutside"
import { HISTORY_TYPE, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { ISectionMarkingProps } from "./SectionMarking"
import updateSection from "./utils/updateSection"

/* Protopia Ecosystem component */
export interface ISectionTopPaddingHandlerProps extends ISectionMarkingProps {
    
}
const SectionTopPaddingHandler = (props: ISectionTopPaddingHandlerProps): JSX.Element => {
    const settings      = useLandingConsoleStore((state:ILandingConsoleStore) => state.settings )  
    const sizes         = useLandingSize()
    const {position, }  = usePosition( props.section ) 
    const ref           = useRef( null )
    const y             = useSyncState<number>( 0 )
    const startDragY    = useSyncState<number>( 0 ) 
    const preY          = useSyncState<number>( 0 ) 
    const ctrlKey       = useSyncState<boolean>( false ) 
    const isOpen        = useSyncState<boolean>( false ) 
    
    useEffect(() => { 
        if( props.section.isHidden || !(settings.linesAndHandlers && settings.sectionPaddings) ||  sizes.width < WINDOW_WIDTH.TABLET) return
        y.set( typeof props.section.paddingTop !== "undefined" ?  props.section.paddingTop : 75 )
        preY.set( typeof props.section.paddingTop !== "undefined" ?  props.section.paddingTop : 75 )
    }, [ props.section, position, settings.linesAndHandlers, settings.sectionPaddings ])
    
    const onDragStart = (evt: MouseEvent) => {
        ctrlKey.set(evt.ctrlKey);
        (evt as any).dataTransfer.setDragImage(evt.target, window.outerWidth, window.outerHeight)
        startDragY.set( evt.clientY - y.get() )
        const sectionEdit = document.querySelectorAll(".landing-section-edit-form")
        sectionEdit.forEach((s: any) => s.style.visibility = "hidden")
        evt.stopPropagation()
    }
    const onDrag = (evt: MouseEvent) => { 
        ctrlKey.set(evt.ctrlKey)
        const y1 = evt.clientY - startDragY.get()
        const yy = Math.round(y1 / 5) * 5
        if( yy >= 0) {
            y.set( yy )
        }
        evt.stopPropagation()
    }
    const onDragEnd = (evt: MouseEvent) => {
        const y1 = evt.clientY - startDragY.get()
        const yy = Math.round(y1 / 5) * 5 
        if( yy >= 0) {
            y.set( yy )
            preY.set( yy )
            set_Y( yy )
        }
        const sectionEdit = document.querySelectorAll(".landing-section-edit-form")
        sectionEdit.forEach((s: any) => s.style.visibility = "visible")
        evt.stopPropagation()
        ctrlKey.set( false )
    } 
    const onChange = (value: number) => { 
        preY.set( value )  
    }
    const onChangeY = () => {
        set_Y( preY.get() )
        onClose()
    }
    const onClose = () => {
        isOpen.set( false )
    }
    const set_Y = (value: number) => {
        const currentLanding: ILanding = { ...useLandingStore.getState().currentLanding }
        const section = currentLanding.sections[ props.i ] 
        const newVal = JSON.parse(JSON.stringify( {
            ...section,
            paddingTop: value,
            paddingBottom: ctrlKey.get() ? value : section.paddingBottom
        }))
        updateSection( 
            newVal,
            {
                data: newVal,
                prevData: section,
                type: HISTORY_TYPE.SECTION,
                title: "Change section's top padding"
            } 
        )
    }

    return props.section.isHidden || !(settings.linesAndHandlers && settings.sectionPaddings)  ||  sizes.width < WINDOW_WIDTH.TABLET
        ? 
        <></>
        :
        <>
            <div 
                className='landing-section-top-padding-handler pe-surface'
                style={{
                    top: y.get(),
                }}
                ref={ ref }
                draggable
                onDragStart={onDragStart}
                onDrag={onDrag}
                onDragEnd={onDragEnd}
            >
                <span className="landing-section-p pl-1">
                    <div className="pr-1">
                        { y.get() }
                    </div>
                    <Popover 
                        position={ Position.TOP_LEFT } 
                        interactionKind={ PopoverInteractionKind.CLICK }
                        isOpen={ isOpen.get() ? true : false }
                        content={ <YHandler 
                            preY={preY.get()}
                            y={y.get()}
                            onChange={onChange} 
                            onChangeY={onChangeY}
                            onClose={onClose}        
                        />} 
                        className=""
                    >
                        <Tooltip position={Position.TOP_LEFT} content={<div className="small letter-spacing-1">{__("Edit")}</div>} className="pr-1 pb-1">
                            <Icon icon="edit" size={ 8 } color="#FFFFFF" className="pointer" onClick={ () => isOpen.set( !isOpen.get() ) } />
                        </Tooltip>
                    </Popover>
                </span>
            </div>    
        </>
}
export default SectionTopPaddingHandler


export const YHandler = (props: any) : JSX.Element => {
    const ref = useRef( null) 
    useClickOutside(ref, props.onClose)

    return <div className="p-2 d-flex" ref={ref}>
        <NumericInput onValueChange={ props.onChange } value={ props.preY } size={Size.SMALL} />
        <Button 
            onClick={props.onChangeY} 
            icon={ props.preY === props.y  ? "blank" : "tick" }  
            size={Size.SMALL} 
            variant="minimal"
        />
        <Button 
            onClick={props.onClose}   
            icon="cross" 
            size={Size.SMALL} 
            variant="minimal"
        />
    </div>
}